import { useQuery } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";
import { api, coverUri } from "../lib/api";
import { useAuth } from "../auth";
import { Spinner, EmptyState, ProgressBar, Button } from "../components/ui";
import { usePlayer } from "../lib/player";
import { Icon } from "../components/icons";

const ORDER = { em_estudo: 0, por_estudar: 1, preparada: 2 };

export default function Estudar() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const player = usePlayer();
  const q = useQuery({ queryKey: ["songs", "", ""], queryFn: () => api("/songs?q=&status=") });
  const slQ = useQuery({ queryKey: ["home-setlists"], queryFn: () => api("/setlists") });
  const data = [...(q.data || [])].sort((a, b) => (ORDER[a.status] ?? 9) - (ORDER[b.status] ?? 9));

  return (
    <>
      <div className="page-header" style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
          <h1 className="t-h1" style={{ flex: 1 }}>Estudar</h1>
          <Link to="/listas" className="chip" data-testid="study-playlists-link"><Icon name="list-music" size={14} /> AS MINHAS LISTAS</Link>
          <Button className="auto sm" icon="play" disabled={!data.length} onClick={() => player.playQueue(data.map((s) => ({ song_id: s.id, title: s.title, artist: s.artist, cover_url: s.cover_url })), 0, { label: "Estudar tudo", path: "/estudar" })} data-testid="study-play-all">ESTUDAR TUDO</Button>
        </div>
        <div className="t-hint" data-testid="study-voice-label">
          A minha voz · <span style={{ color: "var(--on-surface)" }}>{user?.voice || "Sem voz atribuída"}</span>
        </div>
      </div>
      {q.isLoading ? (
        <Spinner />
      ) : (
        <div className="page ulc-fade" style={{ maxWidth: 900 }} data-testid="study-list">
          {(slQ.data || []).length ? (
            <div style={{ marginBottom: 24 }} data-testid="study-official-setlists">
              <div className="t-section" style={{ marginBottom: 10 }}>Alinhamentos oficiais</div>
              <div style={{ display: "flex", gap: 10, overflowX: "auto", paddingBottom: 6 }}>
                {slQ.data.map((sl) => (
                  <Link key={sl.id} to={`/alinhamentos/${sl.id}`} className="card" data-testid={`study-setlist-${sl.id}`} style={{ minWidth: 200, padding: 12, textDecoration: "none", color: "inherit", display: "flex", gap: 10, alignItems: "center" }}>
                    <span style={{ width: 36, height: 36, borderRadius: 999, background: "var(--brand-tertiary)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><Icon name="list" size={16} /></span>
                    <span style={{ minWidth: 0 }}><div style={{ fontFamily: "var(--f-medium)", fontSize: 14, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{sl.name}</div><div className="t-hint">{(sl.songs || sl.song_ids || []).length} músicas</div></span>
                  </Link>
                ))}
              </div>
            </div>
          ) : null}
          {data.length ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {data.map((item) => {
                const slug = item.title.toLowerCase().replace(/\s+/g, "-");
                return (
                  <div key={item.id} className="song-row" data-testid={`study-row-${slug}`} onClick={() => navigate(`/song/${item.id}`)}>
                    <img className="cover" src={coverUri(item.cover_url)} alt="" style={{ width: 56, height: 56, borderRadius: "var(--r-sm)" }} />
                    <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 6 }}>
                      <div style={{ fontFamily: "var(--f-medium)", fontSize: 16, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item.title}</div>
                      <div style={{ color: "var(--on-surface-3)", fontSize: 13 }}>{item.artist}</div>
                      <ProgressBar value={item.progress} />
                    </div>
                    <Link
                      to={`/song/${item.id}?autoplay=1`}
                      data-testid={`study-play-${slug}`}
                      onClick={(e) => e.stopPropagation()}
                      style={{ width: 48, height: 48, borderRadius: 999, background: "var(--brand-primary)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}
                    >
                      <Icon name="play" size={20} color="var(--on-brand)" />
                    </Link>
                  </div>
                );
              })}
            </div>
          ) : (
            <EmptyState icon="musical-note-outline" text="Nenhuma música selecionada para estudo." />
          )}
        </div>
      )}
    </>
  );
}
